<template lang="html">
  <div v-if="loading == 'loading' || loading == 'completed'">
    <div class="loading-bar-container">
      <span :class="['loading-bar', loading]"></span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('overlayStore', ['loading'])
  }
}
</script>

<style lang="css">
.loading-bar-container {
  height: 5px;
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1050
}

.loading-bar {
  display: block;
  background-color: #abcff5;
  height: 100%;
  width: 1%;
  transition: width 400ms ease-in-out
}

.loading-bar.loading {
  width: 30%;
}

.loading-bar.completed {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// LoadingBar.vue?46bf3186